import { Backdrop } from './Backdrop.js'
import { Close } from './Close.js'
import { Content } from './Content.js'
import { Description } from './Description.js'
import { Root } from './Root.js'
import { Title } from './Title.js'
import { Trigger } from './Trigger.js'
import { Viewport } from './Viewport.js'

export const Sheet = {
  Root,
  Trigger,
  Portal,
  Backdrop,
  Viewport,
  Content,
  Handle,
  Title,
  Description,
  Close,
} as const
import { Handle } from './Handle.js'
import { Portal } from './Portal.js'
